module.exports = __webpack_public_path__ + "static/services_bg-e2d061131c231f5b88fb443643c2e228.png";